import { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPage from './pages/AuthPage';
import FeedPage from './pages/FeedPage';
import MessagesPage from './pages/MessagesPage';
import DiscoverPage from './pages/DiscoverPage';
import AIPage from './pages/AIPage';
import './index.css';

const COLORS = ['#C94B30','#1D9E75','#534AB7','#BA7517'];
const getColor = s => COLORS[(s?.charCodeAt(0)||0) % COLORS.length];
const initials = n => (n||'U').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
const NAV = [{ id:'feed', icon:'⊞', label:'Feed' },{ id:'messages', icon:'💬', label:'Messages', badge:true },{ id:'discover', icon:'🧭', label:'Discover' },{ id:'ai', icon:'✨', label:'AI' }];

function AppLayout() {
  const { user, profile, logout } = useAuth();
  const [active, setActive] = useState('feed');
  return (
    <div className="app-layout">
      <nav className="sidebar">
        <div style={{ width:40, height:40, borderRadius:12, background:'linear-gradient(135deg, var(--sunset), var(--flame))', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Sora,sans-serif', fontSize:20, fontWeight:700, color:'white', marginBottom:24, flexShrink:0 }}>U</div>
        <div style={{ display:'flex', flexDirection:'column', gap:4, width:'100%', padding:'0 10px' }}>
          {NAV.map(n => (
            <button key={n.id} onClick={() => setActive(n.id)} title={n.label} aria-label={n.label} style={{ width:48, height:48, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', background: active===n.id ? 'rgba(232,168,56,0.15)' : 'transparent', border:'none', color: active===n.id ? 'var(--sunset)' : 'var(--muted)', fontSize:22, transition:'all 0.2s', position:'relative', cursor:'pointer' }}>
              {n.icon}
              {n.badge && <span style={{ position:'absolute', top:8, right:8, width:8, height:8, borderRadius:'50%', background:'var(--flame)', border:'2px solid var(--earth)' }} />}
            </button>
          ))}
        </div>
        <div style={{ marginTop:'auto', display:'flex', flexDirection:'column', alignItems:'center', gap:8, padding:'0 10px' }}>
          <button onClick={() => setActive('feed')} title="Create post" style={{ width:48, height:48, borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', background:'transparent', border:'none', color:'var(--muted)', fontSize:22, cursor:'pointer' }}>➕</button>
          <div onClick={logout} title="Sign out" style={{ width:40, height:40, borderRadius:'50%', background:getColor(profile?.displayName||user?.displayName), display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600, color:'white', border:'2px solid var(--sunset)', cursor:'pointer', overflow:'hidden' }}>
            {user?.photoURL ? <img src={user.photoURL} alt="avatar" style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : initials(profile?.displayName||user?.displayName)}
          </div>
        </div>
      </nav>
      <main style={{ flex:1, overflow:'hidden', display:'flex' }}>
        {active==='feed' && <FeedPage />}
        {active==='messages' && <MessagesPage />}
        {active==='discover' && <DiscoverPage />}
        {active==='ai' && <AIPage />}
      </main>
    </div>
  );
}

function AppRouter() {
  const { user } = useAuth();
  return user ? <AppLayout /> : <AuthPage />;
}

export default function App() {
  return <AuthProvider><AppRouter /></AuthProvider>;
}
